const test = process.env.REACT_APP_N8N_TEST_API_URL;
const url = process.env.REACT_APP_N8N_API_URL;


export const vectorizeFormulaList = `${url}/get-vector-store-data`;
export const processFormula = `${url}/process-formulas`;
export const getCalcFormula = `${url}/get-calculation`;
export const showDetailUrl = `${url}/show-details`;